import { memo } from "react";
import type { Script } from "@/features/dashboard/types";

interface RowHeaderProps {
  script: Script;
  formatDate: (dateString: string) => string;
  lastUpdated: string | null;
}

export const RowHeader = memo(({ script, formatDate, lastUpdated }: RowHeaderProps) => (
  <div className="space-y-2">
    <div className="space-y-1">
      {script.script_url ? (
        <a
          href={script.script_url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-base font-bold text-foreground leading-snug hover:text-primary transition-colors tracking-tight line-clamp-2 underline-offset-2 hover:underline focus-visible:underline"
        >
          {script.movie_name}
        </a>
      ) : (
        <p className="text-base font-bold text-foreground leading-snug tracking-tight line-clamp-2">
          {script.movie_name}
        </p>
      )}
      {script.custom_message && (
        <p className="text-xs text-muted-foreground leading-normal line-clamp-2">
          {script.custom_message}
        </p>
      )}
    </div>
    <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-muted-foreground tabular-nums">
      <span>{formatDate(script.created_at)}</span>
      {lastUpdated && (
        <>
          <span className="opacity-40">•</span>
          <span>Updated {formatDate(lastUpdated)}</span>
        </>
      )}
    </div>
  </div>
));

RowHeader.displayName = "RowHeader";
